/* AF · CUPONS · copiar código · v1 · 12/08/2026

   Um único ouvinte no documento, por delegação. Serve a section AF · Cupons,
   o bloco de cupom dentro do AF · Produto e qualquer cupom que o editor de
   tema renderizar depois — sem religar nada.

   A trava de instância importa: o arquivo é pedido por mais de uma section,
   e o navegador só baixa uma vez, mas se um dia for embutido duas vezes o
   clique seria tratado em dobro. Daí o window.__afCupons. */
(function(){
  if(window.__afCupons) return;
  window.__afCupons = true;

  // Caminho reserva: navegador sem API de área de transferência, ou página
  // servida fora de HTTPS. Não é bonito, mas é o que funciona nesses casos.
  function copiaAntiga(texto){
    var t=document.createElement('textarea');
    t.value=texto;
    t.setAttribute('readonly','');
    t.style.position='fixed'; t.style.top='-1000px'; t.style.opacity='0';
    document.body.appendChild(t);
    t.select();
    try{ t.setSelectionRange(0, texto.length); }catch(e){}
    var deu=false;
    try{ deu=document.execCommand('copy'); }catch(e){ deu=false; }
    document.body.removeChild(t);
    return deu;
  }

  function avisa(bt){
    var txt=bt.querySelector('[data-af-cup-txt]');
    if(!txt) return;
    if(bt.dataset.timer) clearTimeout(parseInt(bt.dataset.timer,10));
    txt.textContent=bt.dataset.copiado;
    bt.classList.add('is-ok');
    bt.dataset.timer=setTimeout(function(){
      txt.textContent=bt.dataset.rotulo;
      bt.classList.remove('is-ok');
    },2000);
  }

  document.addEventListener('click', function(e){
    var alvo=e.target;
    var bt=(alvo && alvo.closest) ? alvo.closest('[data-af-cup-btn]') : null;
    if(!bt) return;

    var codigo=bt.dataset.codigo||'';
    if(!codigo) return;

    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(codigo)
        .then(function(){ avisa(bt); })
        .catch(function(){ if(copiaAntiga(codigo)) avisa(bt); });
    } else if(copiaAntiga(codigo)){
      avisa(bt);
    }
  });
})();
